export default __webpack_public_path__ + "static/5-60104caac688083aa964f1b56ef7fc11.png";